var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvervoltageZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.2C4 6.0799 4 5.51984 4.21799 5.09202C4.40973 4.71569 4.71569 4.40973 5.09202 4.21799C5.51984 4 6.0799 4 7.2 4H12.8C13.9201 4 14.4802 4 14.908 4.21799C15.2843 4.40973 15.5903 4.71569 15.782 5.09202C16 5.51984 16 6.0799 16 7.2V12.8C16 13.9201 16 14.4802 15.782 14.908C15.5903 15.2843 15.2843 15.5903 14.908 15.782C14.4802 16 13.9201 16 12.8 16H7.2C6.0799 16 5.51984 16 5.09202 15.782C4.71569 15.5903 4.40973 15.2843 4.21799 14.908C4 14.4802 4 13.9201 4 12.8V7.2Z",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L6.95573 10.1513C6.75504 10.4249 6.6547 10.5618 6.65794 10.6761C6.66075 10.7756 6.7079 10.8687 6.78648 10.9298C6.87676 11 7.04645 11 7.38582 11H10V14L13.0443 9.84873C13.245 9.57506 13.3453 9.43822 13.3421 9.3239C13.3392 9.22438 13.2921 9.13134 13.2135 9.07022C13.1232 9 12.9536 9 12.6142 9H10V6Z",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvervoltageZap);
export default __webpack_public_path__ + "static/media/overvoltage-zap.a16fe085ca83e5c2181471d711ef6625.svg";
export { ForwardRef as ReactComponent };